(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-generic-premium"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gw-sticky-acquire')) {
    customElements.define('gw-sticky-acquire', class extends HTMLElement {
      connectedCallback() {
        const target = document.getElementById(this.dataset.target);
        if (!target) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0.05 });
        this.observer.observe(target);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gw-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gw-gallery]');
    if (!gallery) return;
    const index = thumb.dataset.index;

    gallery.querySelectorAll('[data-gw-gallery-slide]').forEach((slide) => {
      const active = slide.dataset.index === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    gallery.querySelectorAll('[data-gw-gallery-thumb]').forEach((button) => {
      const active = button.dataset.index === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });


  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-gw-variant]');
    if (!select) return;
    const section = select.closest('.gw-product');
    const option = select.options[select.selectedIndex];
    section.querySelectorAll('[data-gw-price], [data-gw-sticky-price]').forEach((node) => { node.textContent = option.dataset.price; });
    const button = section.querySelector('.gw-product__form-button button');
    if (button) button.disabled = option.dataset.available !== 'true';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-premium-product"]) return;
  try {
    
  if (!customElements.get('gw-sticky-acquire')) {
    customElements.define('gw-sticky-acquire', class extends HTMLElement {
      connectedCallback() {
        const target = document.getElementById(this.dataset.target);
        if (!target) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0.05 });
        this.observer.observe(target);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gw-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gw-gallery]');
    if (!gallery) return;
    const index = thumb.dataset.index;

    gallery.querySelectorAll('[data-gw-gallery-slide]').forEach((slide) => {
      const active = slide.dataset.index === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    gallery.querySelectorAll('[data-gw-gallery-thumb]').forEach((button) => {
      const active = button.dataset.index === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });

    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-gw-variant]');
    if (!select) return;
    const section = select.closest('.gw-product');
    const option = select.options[select.selectedIndex];
    section.querySelectorAll('[data-gw-price], [data-gw-sticky-price]').forEach((node) => { node.textContent = option.dataset.price; });
    const button = section.querySelector('.gw-product__form-button button');
    if (button) button.disabled = option.dataset.available !== 'true';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
